import React, { Component } from "react";
import { ButtonToolbar, Button, Form, Image, Row } from "react-bootstrap";
import { Field } from "../../component/FieldComponent";
import { get, isFunction } from "lodash";
import ForwardToTeam from "../issueList/forwardToTeam";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  setIssueStatusAction,
  postCommentAction,
  replyAction,
  issueClarificationAction
} from "../../actions/issuesListAction.actions";
import { getIssueList } from "../../actions/common.action";
import { bindActionCreators } from "redux/es/redux";
import { modifyDataForPost } from "./helper";
import {
  ERROR_MSG,
  FILE_FORMATS,
  STATUS,
  MAX_CHARACTER_LIMIT
} from "../../constant";
import ReassignForClarification from "../issueList/reassignForClarrification";
import MarkAsDuplicate from "../issueList/markAsDuplicate";
import ChangeStatus from "../issueList/changeStatus";
import AddDecision from "../agendaDetails/AddDecision.issueList";
import {
  getIssueMeetingByIdAction,
  getIssueDetails
} from "../../actions/issueDetail.action";
import { withRouter } from "react-router-dom";
import LoaderTemplate from "../../component/LoaderTemplate";
import { ActionLoaderTemplate } from "../../component/LoadersTemplate";
import DisplayByPermission from "../../component/DisplayByPermission";
import { LoaderPage } from "../../component/Loader";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  changeProjectStatus,
  getProjectDetails
} from "../../actions/projectDetail.action";
import {
  UploadAttachmentsWithTitleComponent,
  DisplayAttachments
} from "../reusableComponent";
import IconPin from "../../assets/icon-pin.png";
import { unHoldIssueAction } from "../../actions/issues.action";
import AddDecisionConfirmationModal from "../issueList/addDecisionCofirmationModal";
import { getAgendaIssueAction } from "../../actions/mom.action";
import { handleLanguage, handlePaste } from "../../helper";
import CircleWithExclamation from "../../assets/circle-with-exclamation.svg";
import { successToastStyle, errorToastStyle } from "../../customToast";
import InfoIcon from "../../assets/small-info-icon.svg";
import TooltipComponent from "../../component/TooltipComponent";
import uparrow from "../../assets/uparrowsvg.svg";
import "../../sass/styling/_Newbutton.scss";
import { IssueEditButton } from "../issueDetail/IssueEditButton";
const FIXED_ACTIONS = {
  "REASSIGN FOR CLARIFICATION": "REASSIGN FOR CLARIFICATION",
  "FORWARD TO TEAM": "FORWARD TO TEAM",
  REPLY: "REPLY",
  "ADD DECISION": "ADD DECISION",
  Mark_As_Duplicate: "Mark_As_Duplicate"
};

let severity = {
  PRIMARY: "btn-orange",
  SECONDARY: "btn-blue",
  TERNARY: "btn-orange-invert",
  default: "btn-orange"
};

const ACTION_TYPE = "WITH_COMMENT";

const MESSAGES_CONSTANT = {
  "Verify and Send for Consideration":
    "Verify & assign to PMG for further action",
  "Send for Under Process":
    "Verify & assign to its corresponding Recipient Ministry/State",
  "Send to Decision": "Assign to PMG for confirming the resolution of issue",
  "Add Decision": "Add decision taken in meeting or by higher authority",
  Reply: "Reply on requested clarification",
  "Forward to Team": "Forward to my team(s) for further action",
  "Reject Issue": "Not valid and outside the ambit of PMG",
  Resolve: "Confirm issue resolution and assign to PMG for closure",
  Hold: "Issue on hold and can't be part of PMG monitoring for the time being",
  "Reassign For Clarification":
    "Reassign to other stakeholder for issue/update clarification",
  Unhold: "Unhold to revert the issue to its previous stage",
  addMoreIssue: "Add Issue",
  markAsDuplicate: "Mark Duplicate"
};

const ToolTip = ({
  text,
  children,
  id,
  containerClass,
  placement = "bottom"
}) => {
  return (
    <OverlayTrigger
      defaultShow={false}
      placement={placement}
      overlay={
        <Tooltip id={id} className={`issues-actions-tooltip ${containerClass}`}>
          {text || null}
        </Tooltip>
      }
    >
      {children}
    </OverlayTrigger>
  );
};
class MarkDuplicatebtn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      action: "",
      files: [],
      showAddDecisionConfirmationModal: false,
      agendasAssociatedWithIssue: [],
      checkAgenda: true,
      canUploadVideo: true,
      languageError: null,
      pasteError: false,
      pastedText: ""
    };
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { resetAction } = nextProps;
    // eslint-disable-next-line no-unused-expressions
    resetAction;
  }

  onChange = (value, key) => {
    localStorage.setItem("DisplayButton", "0");
    if (
      value == "REASSIGN FOR CLARIFICATION" ||
      "FORWARD TO TEAM" ||
      "Mark_As_Duplicate"
    ) {
      this.props.onCloseButton("1");
      this.props.markDuplicateBTN("1");
    }
    if (value == "") {
      this.props.onCloseButton("0");
    }

    this.setState({ [key]: value }, () => {
      if (window.event.inputType === "insertFromPaste") {
        this.pasteLanguage();
      }
    });
    if (key === "comment") {
      if (value.length > MAX_CHARACTER_LIMIT) {
        value = value.slice(0, MAX_CHARACTER_LIMIT);
      }
    }
  };

  onError = (value, key) => {
    this.setState(prevState => ({
      error: {
        ...prevState.error,
        [key]: value
      }
    }));
  };
  handleMarkBTN = () => {
    this.props.markDuplicateBTN("0");
  };
  onPostComment = () => {
    const {
      issueDetails: { id },
      postCommentDispatch,
      callApiOnSuccess
    } = this.props;
    const { files, comment } = this.state;

    // error
    if (comment === undefined || !comment.trim() || comment === "") {
      this.setState(prevState => ({
        languageError: false,
        pasteError: false,
        error: {
          ...prevState.error,
          comment: {
            error: comment === undefined || !comment.trim() || comment === "",
            message:
              comment === undefined || !comment.trim() || comment === ""
                ? ERROR_MSG.DEFAULT_MSG
                : ""
          }
        }
      }));
    } else {
      const modifyData = modifyDataForPost({ files, comment, id });
      this.setState(
        {
          isCommentLoading: STATUS.LOADING
        },
        async () => {
          const resp = await postCommentDispatch(undefined, modifyData);
          if (resp) {
            const { status, message } = resp;
            (status &&
              toast.success(
                <p className="toast-text-alignment">{message}</p>,
                successToastStyle
              )) ||
              toast.error(
                <p className="toast-text-alignment">{message}</p>,
                errorToastStyle
              );
            isFunction(callApiOnSuccess) && callApiOnSuccess();
            this.setState(
              prevState => ({
                isCommentLoading: (status && STATUS.SUCCESS) || STATUS.ERROR,
                comment: "",
                files: [],
                reset: true,
                error: {
                  ...prevState.error,
                  comment: {}
                }
              }),
              () => {
                this.setState({
                  reset: false
                });
              }
            );
          } else {
            toast.error(
              <p className="toast-text-alignment">
                {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
              </p>,
              errorToastStyle
            );
          }
        }
      );
    }
  };

  //
  onActionClick = value => {
    this.props.onCloseButton("1");
    const { name, actionType } = value;
    this.setState({
      action: name,
      actionType
    });
  };

  // action buttons
  createTemplateForAction = () => {
    const { actionsData, issueDetails } = this.props;
    const actions =
      get(actionsData, "actions") || get(issueDetails, "actions") || [];
    return actions.map((value, index) => {
      return (
        get(value, "name") && (
          <ToolTip text={get(value, "description")}>
            <Button
              className={`${severity[
                get(value, "workflowActionSeverity", "")
              ] || severity.default} no-padding-new 
                ${
                  get(value, "name", "NA") == "REJECT ISSUE"
                    ? "new-rejectissue-btn"
                    : null
                }`}
              onClick={e => {
                this.onActionClick(value);
              }}
              key={`button-${index}`}
            >
              {get(value, "name", "NA")}
            </Button>
          </ToolTip>
        )
      );
    });
  };

  onDelete = e => {
    const { resetAction } = this.props;
    resetAction(e);
  };
  handleButtonClose = () => {
    this.props.onCloseButton("0");
  };
  // set issue status
  setIssueStatus = async e => {
    const { action } = this.state;
    const {
      setIssueStatusDispatch,
      issueDetails = {},
      callApiOnSuccess
    } = this.props;
    const resp = await setIssueStatusDispatch(undefined, {
      action,
      issueCommentCO: {
        issueId: get(issueDetails, "id", null)
      }
    });
    if (resp) {
      const { status, message } = resp;
      (status &&
        toast.success(
          <p className="toast-text-alignment">{message}</p>,
          successToastStyle
        )) ||
        toast.error(
          <p className="toast-text-alignment">{message}</p>,
          errorToastStyle
        );
      typeof callApiOnSuccess === "function" && callApiOnSuccess();
      this.setState({
        action: ""
      });
    }
  };

  handleClose = () => {
    this.setState({
      action: null
    });
  };

  getImageStatus = status => {
    this.setState({
      imageStatus: status
    });
  };

  onVerifyProject = () => {
    const { issueDetails, callApiOnSuccess } = this.props;
    this.setState(
      {
        isProjectVerifing: STATUS.LOADING
      },
      async () => {
        const response = await changeProjectStatus(undefined, {
          comment: "Project is verified.",
          projectId: issueDetails && issueDetails.project.id,
          projectStatus: "VERIFIED",
          isIssueVerified: true
        });
        const { data } = response;
        data.status
          ? toast.success(
              <p className="toast-text-alignment">{data.message}</p>,
              successToastStyle
            )
          : toast.error(
              <p className="toast-text-alignment">{data.message}</p>,
              errorToastStyle
            );
        this.setState(
          { isProjectVerifing: false, action: null, actionType: null },
          () => {
            callApiOnSuccess && callApiOnSuccess();
          }
        );
      }
    );
  };

  onSuccessUploadOfAttachmets = async data => {
    try {
      this.setState(prevState => ({ files: [...prevState.files, data] }));
    } catch (error) {
      console.error(error.message);
    }
  };

  // uploded comes tru in case of file
  // is uploaded
  onToggleAttachment = index => {
    this.setState(prevState => {
      return {
        toggleAttachementDisplay: !prevState.toggleAttachementDisplay
      };
    });
  };

  // delete attachments
  onRemoveFile = ({ id }) => {
    try {
      this.setState(prevState => ({
        files: prevState.files.filter(val => val.id !== id)
      }));
    } catch (error) {
      console.log(`Error while deleting the image ${error.message}`);
    }
  };

  unHoldIssue = async () => {
    let {
      issueDetails: { id },
      unHoldIssueAction,
      callApiOnSuccess
    } = this.props;

    let resp = await unHoldIssueAction(id);
    if (resp) {
      this.setState(
        { isProjectVerifing: false, action: null, actionType: null },
        () => {
          callApiOnSuccess && callApiOnSuccess();
        }
      );
    }
  };
  handleCloseAddDecisionConfirmationModal = () => {
    this.setState({
      showAddDecisionConfirmationModal: false
    });
  };

  showAddDecisionConfirmationModal = () => {
    const {
      issueDetails,
      defaultOpen,
      callApiOnSuccess,
      filterArray,
      meetingListData
    } = this.props;
    const {
      agendasAssociatedWithIssue,
      showAddDecisionConfirmationModal
    } = this.state;
    return agendasAssociatedWithIssue.length !== 0 ? (
      <>
        <AddDecisionConfirmationModal
          show={showAddDecisionConfirmationModal}
          handleClose={this.handleCloseAddDecisionConfirmationModal}
          issueDetails={issueDetails}
          defaultOpen={defaultOpen}
          callApiOnSuccess={callApiOnSuccess}
          filterArray={filterArray}
          meetingListData={meetingListData}
          agendasAssociatedWithIssue={agendasAssociatedWithIssue}
          showAddDecisionConfirmationModal={showAddDecisionConfirmationModal}
        />
      </>
    ) : (
      <>
        <AddDecision
          show={true}
          meetingListData={get(meetingListData, "data")}
          handleClose={() =>
            this.setState({
              showAddDecisionConfirmationModal: false
            })
          }
          issues={issueDetails}
          project={
            get(issueDetails, "project") || get(issueDetails, "projectIssueDTO")
          }
          callApiOnSuccess={callApiOnSuccess}
          defaultOpen={defaultOpen}
          issueListStatus={true}
          filterArray={filterArray}
          showSaveAsDraft={false}
          callFromIssueAction={true}
        />
      </>
    );
  };

  getAgendaListForIssue = async () => {
    const { issueDetails } = this.props;
    const response = await getAgendaIssueAction(
      undefined,
      issueDetails.id,
      this.state.checkAgenda
    );
    if (response) {
      if (response.data.data !== null) {
        this.setState({
          agendasAssociatedWithIssue: response.data.data
        });
      }
    } else {
      toast.error(
        <p className="toast-text-alignment">
          {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
        </p>,
        errorToastStyle
      );
    }
    this.setState({ showAddDecisionConfirmationModal: true });
  };
  inputLanguage = event => {
    if (window.event.inputType !== "insertFromPaste") {
      let hasInputValue = handleLanguage(event);
      this.setState({
        languageError: hasInputValue,
        pasteError: false
      });
    }
  };

  pasteLanguage = () => {
    let { filterString, hasBadValue } = handlePaste(this.state.comment);
    if (hasBadValue === true) {
      this.setState({
        pasteError: hasBadValue,
        comment: filterString
      });
    }
  };

  render() {
    const {
      action,
      comment,
      error,
      files,
      actionType,
      isProjectVerifing,
      isCommentLoading,
      imageStatus,
      toggleAttachementDisplay,
      canUploadVideo,
      pasteError,
      languageError
    } = this.state;
    const {
      issueDetails,
      replyActionDispatch,
      issueClarificationDispatch,
      defaultOpen,
      meetingListData,
      actionsData,
      callApiOnSuccess,
      isLoading,
      isApiLoading,
      filterArray,
      handleOnClick,
      projectData
    } = this.props;

    const actionsInfo = actionsData || issueDetails || {};
    const {
      actions,
      askForClarificationList,
      replyToList,
      markAsDuplicateList
    } = actionsData || issueDetails || {};
    const { project, projectIssueDTO } = actionsInfo;
    const projectStatus =
      get(project, "status") || get(projectIssueDTO, "status");
    const isActionAvailable = (actions || []).find(value => {
      return value && value.name === action;
    });
    return (
      <React.Fragment>
        {/* <LoaderPage
          loading={
            isCommentLoading === STATUS.LOADING ||
            imageStatus === STATUS.LOADING ||
            isApiLoading === STATUS.LOADING ||
            isProjectVerifing
          }
        /> */}
        <DisplayByPermission display={!action || (!action && defaultOpen)}>
          <DisplayByPermission display={get(actionsInfo, "markAsDuplicate")}>
            <ToolTip text={MESSAGES_CONSTANT["markAsDuplicate"]}>
              <Button
                className={`btn-orange-invert no-padding-new button-more-issue`}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.onChange(FIXED_ACTIONS["Mark_As_Duplicate"], "action");
                }}
                style={{
                  display: this.props.Displaybuttons == 1 ? "none" : null,
                  position: get(actionsInfo, "markAsDuplicate")
                    ? "absolute"
                    : null
                }}
              >
                Mark Duplicate
              </Button>
            </ToolTip>
          </DisplayByPermission>
        </DisplayByPermission>
        <DisplayByPermission
          display={action === FIXED_ACTIONS["Mark_As_Duplicate"]}
        >
          <MarkAsDuplicate
            headerText="Mark As Duplicate"
            issueDetails={issueDetails}
            options={
              markAsDuplicateList && markAsDuplicateList.length
                ? markAsDuplicateList
                : []
            }
            callApiOnSuccess={callApiOnSuccess}
            defaultOpen={defaultOpen}
            resetAction={this.handleClose}
            onCloseButton={this.handleButtonClose}
            markDuplicateBTN={this.handleMarkBTN}
          />
        </DisplayByPermission>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    isApiLoading: state.issueActionReducer.isApiLoading,
    meetingStatus: state.issueDetailsReducer.meetingStatus,
    meetingListData: state.issueDetailsReducer.meetingListData
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setIssueStatusDispatch: setIssueStatusAction,
      postCommentDispatch: postCommentAction,
      getIssueListDispatch: getIssueList,
      replyActionDispatch: replyAction,
      issueClarificationDispatch: issueClarificationAction,
      getIssueMeetingByIdDispatch: getIssueMeetingByIdAction,
      getIssueDetailsDispatch: getIssueDetails,
      getProjectDetails,
      unHoldIssueAction
    },
    dispatch
  );
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MarkDuplicatebtn)
);
